import * as _ from 'underscore';

import ACTIONS from '../actions';

const exerciseTree = (state = {}, action) => {
    let newState = {};
    switch (action.type) {
        case ACTIONS.CALENDAR_ADD_PROGRAM_WORKOUTS:
            newState = { ...state };
            if (action.payload.entities.setExercises) {
                Object.keys(action.payload.entities.setExercises).forEach(
                    key => {
                        newState[key] = {
                            ...action.payload.entities.setExercises[key],
                            key: action.payload.entities.setExercises[key].id,
                            setKey:
                                action.payload.entities.setExercises[key].set_id
                        };
                    }
                );
            }
            return newState;
        case ACTIONS.DAYS_RELOAD:
            newState = { ...action.payload.entities.setExercises };
            Object.keys(newState).forEach(key => {
                newState[key].key = newState[key].id;
                newState[key].setKey = newState[key].set_id;
            });
            return {
                ...state,
                ...newState
            };
        case ACTIONS.DAYS_CLEAR:
            return {};
        case ACTIONS.BLOCK_ADD_EXERCISE:
            newState = {
                ...state,
                [action.exercise.key]: action.exercise
            };
            return newState;
        case ACTIONS.BLOCK_UPDATE_EXERCISE:
            return {
                ...state,
                [action.setExercise.key]: action.setExercise
            };
        case ACTIONS.BLOCK_UPDATE_EXERCISE_IDS:
            newState = {
                ...state,
                [action.setExercise.key]: {
                    ...state[action.setExercise.key],
                    id: action.setExercise.id,
                    set_id: action.setExercise.set_id
                }
            };
            return newState;
        case ACTIONS.BLOCK_UPDATE:
            newState = {
                ...state
            };
            if (action.block.exerciseKeys) {
                for (let i = 0; i < action.block.exerciseKeys.length; i++) {
                    const order = i + 1;
                    if (
                        newState[action.block.exerciseKeys[i]] &&
                        newState[action.block.exerciseKeys[i]].order !== order
                    ) {
                        newState[action.block.exerciseKeys[i]].order = order;
                    }
                }
            }
            return newState;
        case ACTIONS.SESSION_COPY:
            newState = {
                ...state
            };
            const hasItems =
                action.session.sets instanceof Array
                    ? action.session.sets.length
                    : Object.keys(action.session.sets).length;
            if (hasItems) {
                _.map(action.session.sets, set => {
                    if (set.exercises.length) {
                        set.exercises.map(ex => {
                            ex.key = ex.id;
                            newState = {
                                ...newState,
                                [ex.id]: ex
                            };
                        });
                    }
                });
            }
            return newState;
        default:
            return state;
    }
};

export default exerciseTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/exerciseTree.js